import styled from "styled-components"
import { StyledLinkContent } from "../../global-header/partials/StyledLink"

export interface StyledHeroHighlightProps {
  mobile_only: boolean
  image_exists: boolean
  highlight_spacing: boolean
}
export interface StyledHeroAssetProps {
  img: string
  mobile_img: string
  image_exists: boolean
}

export interface StyledHoverProps {
  hover_icon: boolean
}

export const StyledHero = styled.div`
  box-shadow: 0 0 16px ${(props) => props.theme.colors.darkGrey10};
  background-color: ${(props) => props.theme.colors.white};
  width: 100%;
  max-width: ${(props) => props.theme.breakPoints.max};
  margin: 0 auto;
`
export const StyledHeroContainer = styled.div`
  ${(props) => props.theme.mixins.container}
  display: flex;
  @media (min-width: ${(props) => props.theme.breakPoints.tablet}) {
    min-height: 540px;
    justify-content: space-between;
  }
  @media (max-width: ${(props) => props.theme.breakPoints.tablet}) {
    flex-direction: column;
    padding: 0;
  }
`
export const StyledHeroCard = styled.div`
  @media (min-width: ${(props) => props.theme.breakPoints.tablet}) {
    padding: 80px 32px 32px 0;
  }
  @media (max-width: ${(props) => props.theme.breakPoints.tablet}) {
    padding: 24px;
    order: 1;
  }
  @media (max-width: ${(props) => props.theme.breakPoints.mobile}) {
    padding: 24px 16px;
  }
`
export const StyledHeroBreadcrumbs = styled.div`
  margin: 0 0 8px;

  & a {
    ${(props) => props.theme.mixins.label};
    color: ${(props) => props.theme.colors.darkGrey60};
    margin-left: 4px;

    &:before {
      content: "/";
      margin-right: 4px;
    }
    &:nth-of-type(1) {
      margin-left: 0;

      &:before {
        display: none;
      }
    }
  }
`
export const StyledHeroTitle = styled.h1`
  ${(props) => props.theme.mixins.h1}
  &:after {
    ${(props) => props.theme.mixins.headingAccent};
  }
`
export const StyledHeroDescription = styled.div`
  margin: 16px 0 0;

  & p {
    ${(props) => props.theme.mixins.body}
  }
`
export const StyledHeroButtons = styled.div`
  margin: 32px 0 0;
  display: flex;
  @media (max-width: ${(props) => props.theme.breakPoints.tablet}) {
    margin: 24px 0 0;
  }

  & .button-v2--text {
    padding-top: 0;
    padding-bottom: 0;
    min-height: 0;
  }
`
export const StyledHeroAsset = styled.div<StyledHeroAssetProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  @media (min-width: ${(props) => props.theme.breakPoints.tablet}) {
    width: 600px;
    max-width: 600px;
  }
  @media (max-width: ${(props) => props.theme.breakPoints.tablet}) {
    width: 100%;
    ${(props) =>
      props.image_exists &&
      `
    height: 300px;
    `}
  }
  background-image: url(${(props) => props.img});
  ${(props) =>
    props.mobile_img &&
    `
    @media (max-width: ${props.theme.breakPoints.tablet}) {
      background-image: url(${props.mobile_img});
    }
  `}
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
`

export const StyledHeroHighlight = styled.div<StyledHeroHighlightProps>`
  @media (min-width: ${(props) => props.theme.breakPoints.tablet}) {
    width: 480px;
    padding: 24px;
  }
  @media (max-width: ${(props) => props.theme.breakPoints.tablet}) {
    padding: 0 24px 24px 24px;
  }
  ${(props) =>
    props.mobile_only
      ? `   
    @media (min-width: ${props.theme.breakPoints.tablet}) {
        display: none;
    }
    @media (max-width: ${props.theme.breakPoints.tablet}) {
        order: 2;
    }
    `
      : `
    @media (max-width: ${props.theme.breakPoints.tablet}) {
        display: none;
    }
    `}
  ${(props) =>
    props.highlight_spacing &&
    `
    @media (min-width: ${props.theme.breakPoints.tablet}) {
      width: 100%;
      padding: 24px 0;
    }
    @media (max-width: ${props.theme.breakPoints.tablet}) {
      padding: 0;
    }   
        `}
`

export const StyledProgramLogoWrapper = styled.div`
  padding: 16px 0 21px 0;
  width: fit-content;
`
export const StyledProgramLogo = styled.div<StyledHoverProps>`
  position: relative;

  ${StyledLinkContent} {
    img {
      height: 26px;
      padding: 0;
    }
  }
`
